export const deploymentName = (): string => (window as any)._env_?.DEPLOYMENT_NAME || 'Faida';

export const moscowDate = (now = new Date()): string => new Intl.DateTimeFormat('en-CA', {
  timeZone: 'Europe/Moscow', year: 'numeric', month: '2-digit', day: '2-digit',
}).format(now);

export const gpsStatusText = (meta: any, count: number): string => {
  if (!meta) return 'Ожидание данных ГЛОНАСС';
  const parts = [`Машины на карте: ${count}`];
  if (meta.staleVehicles) parts.push(`устаревшие позиции: ${meta.staleVehicles}`);
  if (meta.missingVehicles) parts.push(`нет позиций: ${meta.missingVehicles}`);
  if (meta.error || meta.errors?.length) parts.push('ГЛОНАСС временно недоступен');
  return parts.join(' · ');
};
